export default __webpack_public_path__ + "static/media/rescue_submit.35dfb831.png";